module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/typography/table-with-colors/table-with-colors.component.scss
// module id = ./src/app/features/typography/table-with-colors/table-with-colors.component.scss
// module chunks = main